import ColorPicker from '@/src/components/ColorPicker/ColorPicker';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { Item as ItemWrapper } from 'src/components/Layouts';
import Slider from 'src/components/Slider/MarginSlider';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const TabStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, isConvertible } = props;
  const { gapUnderTab, activeTabColor, regularTabColor } = data;

  const handleOnGapUnderTabChange = (gapUnderTab) => {
    onChange({ gapUnderTab });
  };
  const handleOnActiveTabColorChange = (activeTabColor) => {
    onChange({ activeTabColor });
  };
  const handleOnRegularTabColorChange = (regularTabColor) => {
    onChange({ regularTabColor });
  };

  return (
    <React.Fragment>
      <Slider
        min={0}
        max={240}
        customIcon={
          <Icon
            type='icona-verticalgap'
            className={css.icon}
            onClick={(e) => e.stopPropagation()}
          />
        }
        title={getI18n('general.gapUnderTab')}
        value={gapUnderTab}
        onChange={handleOnGapUnderTabChange}
      />
      {!isConvertible && (
        <React.Fragment>
          <ItemWrapper title={getI18n('general.regularTabColour')} size='small'>
            <ColorPicker
              multi
              onChange={handleOnRegularTabColorChange}
              color={regularTabColor}
            />
          </ItemWrapper>
          <ItemWrapper title={getI18n('general.activeTabColour')} size='small'>
            <ColorPicker
              multi
              onChange={handleOnActiveTabColorChange}
              color={activeTabColor}
            />
          </ItemWrapper>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default TabStyle;
